const ACCESS_TOKEN_KEY = 'accessToken';
const LEGACY_JWT_TOKEN_KEY = 'jwtToken';

const readInitialToken = (): string | null => {
  try {
    const fromNewKey = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (fromNewKey) return fromNewKey;
    const fromLegacyKey = localStorage.getItem(LEGACY_JWT_TOKEN_KEY);
    return fromLegacyKey || null;
  } catch {
    return null;
  }
};

let accessToken: string | null = readInitialToken();

type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string | null): void => {
  accessToken = token;
  try {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN_KEY, token);
      // Clean up legacy key if present
      localStorage.removeItem(LEGACY_JWT_TOKEN_KEY);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(LEGACY_JWT_TOKEN_KEY);
    }
  } catch {
    // Ignore storage errors (e.g., private mode)
  }
  listeners.forEach((listener) => listener(accessToken));
};

export const clearAccessToken = (): void => {
  setAccessToken(null);
};

export const subscribeToAccessToken = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
